import {ChipExpression} from "@nrwl/query-emitter";

export const SqlWhereGrammar = {
  getExpression: (input) => {
    return {
        keyword: input.keyword? input.keyword.explain() : null,
        operator: input.operator? input.operator.explain() : null,
        operands: input.anything? input.anything.explain() : null,
        logicalOp: null
      }
  },
  Query: {
    explain() {
      const result = [];
      result.push(this.firstOperand.explain());
      // todo otherOperands are AND's or ORs. Need to think how they will be represented.
      if (this.otherOperands && this.otherOperands.elements.length > 0) {
        this.otherOperands.elements.forEach((node) => {
          result.push(node.explain());
        });
      }
      return result;
    }
  },
  And: {
    explain() {
      const result = this.secondOperand.explain();
      result.logicalOp = 'AND';
      return result;
    }
  },
  Or: {
    explain() {
      const result = this.secondOperand.explain();
      result.logicalOp = 'OR';
      return result;
    }
  },
  Factor: {
    explain() {
      return this.firstOperand.explain();
    }
  },
  Parens: {
    explain() {
      // a demo how we are going to support parenthesis in SQL WHERE expression

      const ChipExpressionGroup = {
        group: [] as ChipExpression[],
        isGroup: true
      };
      ChipExpressionGroup.group = this.firstOperand.explain();
      return ChipExpressionGroup;

    }
  },
  Term: {
    explain(input) {
      return this.expression.explain(this.expression);
    }
  },
  FullExpression: {
    explain(input) {
      return SqlWhereGrammar.getExpression(input);
    }
  },
  Keyword: {
    explain(input) {
      return this.text;
    }
  },
  Operator: {
    explain(input) {
      return this.text;
    }
  },
  Numeric: {
    explain(input) {
      return this.text;
    }
  },
  PlainAscii: {
    explain(input) {
      return this.text;
    }
  },
  CommaList: {
    explain(input) {
      // see this definition of comma_list:
      // comma_list  <- first:any_value others:(__* "," __* any_value)*                   <CommaList>
      const result = [];
      // this is what is placed under 'first' label
      if (this.first) {
        result.push(this.first.explain());
      }

      // the 'others' label is created, wrapper TreeNode created. True content is in others.elements
      // Notice the PEG syntax used others:(.... any_value) syntax. So yet another  level of indirection
      // will be created. This is reflected in the code below
      // that wraps these options. Howe
      if (this.others && this.others.elements.length > 0) {
        this.others.elements.forEach((node) => {
          result.push(node.any_value.explain());
        });
      }
      return result;
    }
  },
  QuotedString: {
    explain(input) {
      if (this.elements.length > 2) {
        // we want just the text. no quotes
        return this.elements[1].text;
      }
      return '';
    }
  }
}
